<template lang="pug">
  .empty-panel
    .flex-wrap
      .info-box
        .main-info Track all sales by product, brand, value, people and quantity of units sold.
        .check-list
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading SALES TRACKER
              p Tracking individual sales perfomance to total quantity of units sold of value.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading TOP PERFORMERS
              p See who your best sales performers are by product & brand.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading DASHBOARDS
              p View macro performance at a glance in our easy to use dashboards.

        router-link(:to="ctaRoute")
          .el-button.pink GET STARTED

      .img-box
        img(src='@/assets/images/emptystates/br-sales-phone.png')
</template>

<script>
export default {
  props: {
    ctaRoute: {
      required: true
    }
  }
};
</script>
